<template>
  <div class="common__main-content bg-white">
    <div class="form-group">
      <label>Tutor ID</label>
      <div>{{tutor.id}}</div>
    </div>
    <div class="form-group">
      <label>First Name</label>
      <div>{{tutor.firstName}}</div>
    </div>
    <div class="form-group">
      <label>Middle Name</label>
      <div>{{tutor.middleName}}</div>
    </div>
    <div class="form-group">
      <label>Last Name</label>
      <div>{{tutor.lastName}}</div>
    </div>
    <div class="form-group">
      <label>Position</label>
      <div>{{tutor.position && tutor.position.name}}</div>
    </div>
    <div class="form-group">
      <label>Nationality</label>
      <div>{{tutor.nationality && tutor.nationality.name}}</div>
    </div>
    <div class="form-group">
      <label>Phone</label>
      <div>{{tutor.phone1}}</div>
    </div>
    <div class="form-group">
      <label>住所</label>
      <div>{{tutor.addressJapanese}}</div>
    </div>
    <div class="form-group">
      <label>Address</label>
      <div>{{tutor.address}}</div>
    </div>
    <div class="form-group">
      <label>Hire Date</label>
      <div>{{tutor.hireDate | date}}</div>
    </div>
    <div class="form-group">
      <label>Email 1</label>
      <div>{{tutor.email1}}</div>
    </div>
    <div class="form-group">
      <label>Email 2</label>
      <div>{{tutor.email2}}</div>
    </div>
    <div class="form-group">
      <label>Emergency 1</label>
      <div>{{tutor.emergencyContact1}}</div>
    </div>
    <div class="form-group">
      <label>Emergency 2</label>
      <div>{{tutor.emergencyContact2}}</div>
    </div>
    <div class="form-group">
      <label>Birthday</label>
      <div>{{tutor.birthday | date}}</div>
    </div>
    <div class="form-group">
      <label>Gender</label>
      <div>{{tutor.gender | gender}}</div>
    </div>
    <div class="form-group">
      <label>Leave date</label>
      <div>{{tutor.leaveDate | date}}</div>
    </div>
    <div class="form-group">
      <label>Educational background</label>
      <div>{{tutor.academicBackground}}</div>
    </div>
    <div class="form-group">
      <label>Teach Exp</label>
      <div>{{tutor.teachingExperience}}</div>
    </div>
    <div class="form-group">
      <label>Total Exp</label>
      <div>{{tutor.totalExperience}}</div>
    </div>
    <div class="form-group">
      <label>LMS UserID</label>
      <div>{{tutor.lmsUserId}}</div>
    </div>
    <div class="form-group">
      <label>LMS AccessToken</label>
      <div>{{tutor.lmsToken}}</div>
    </div>
    <div class="form-group">
      <label>Priority Waiting flag</label>
      <div>{{tutor.waitingPriority ?
        'Priority to waiting' : 'No priority to waiting'}}</div>
    </div>
    <div class="form-group">
      <label>Note</label>
      <div>{{tutor.note}}</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import moment from 'moment'
import { Tutor } from '@/store/tutors/types';

export default Vue.extend({
  props: {
    tutor: {
      type: Object as PropType<Tutor>,
      required: true,
    },
  },

  filters: {
    gender(code: number): string {
      switch (code) {
        case 0:
          return 'male';
        case 1:
          return 'female';
        case 2:
          return 'other'
        default:
          return '';
      }
    },
    date(date: Date|null): string {
      if (!date) {
        return ''
      }
      const m = moment(date)
      return m.isValid() ? m.format('YYYY/MM/DD') : ''
    },
  },
})
</script>

<style scoped>
.form-group {
  word-wrap: break-word;
}
</style>
